// eslint-disable-next-line import/prefer-default-export
export const editEventsForServiceRequestAdpater = ({ wells }) =>
  wells?.map((well) => ({
    IdSolicitudServicioPozo: well?.idSolicitudServicioPozo,
    IdEventoPozo: well?.selectedEvent?.eventoPozoId,
    NombreEvento: well?.selectedEvent?.nombre,
    TipoImputacion: well?.imputationObject?.imputationType?.id,
    IdObjetoImputacion: well?.imputationObject?.imputationObject?.id,
    NombrePozo: well?.pozo?.nombre
  }));
